import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";

import logo from "../../../icons/myIcons/logo.png";
import {
  authenticate,
  setLoading,
  setUserDetails,
} from "../../../feature/authSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputField from "../../components/Fields/inputFields";
import { Button, Modal, Nav, Tab } from "react-bootstrap";
import PrimaryButton from "../../components/Fields/primaryButton";
import Slider from "../../components/swiper/swiper";
import { emailValidation } from "../../../function/validation";
import { forgotPasswordApi } from "../../../service/auth/forgotPassword";
import ReCAPTCHA from "react-google-recaptcha";

function ForgotPasswordAuth(props) {
  const dispatch = useDispatch();

  const notifyTopRight = (e, s) => {
    if (s == "s") {
      toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [loadingActive, setLoadingActive] = useState(false);

  function onForgot(e) {
    if (!recaptchaValue) {
      toast.error("Captcha is required");
      return;
    }
    if (emailValidation(email)) {
      setLoadingActive(true);
      var data = {
        Code: "",
        Action: "",
        Controller: "",
        ActionButton: 0,
        ResponseMessage: "",
        ApiCallStatus: 0,
        StatusCode: 0,
        Message: "",
        Email: email,
        ForgotPasswordCode: "",
                recaptchaValue: recaptchaValue

            }
            dispatch(forgotPasswordApi(data, (res) => {
                setEmail("")
                notifyTopRight("Email sent successfully", "s")
                setLoadingActive(false)
                resetCaptcha()
                setRecaptchaValue('')
            }, () => {
                resetCaptcha()
                setRecaptchaValue('')
            // notifyTopRight("Invalid email", "e")
            setLoadingActive(false);
          }
        )
      );
    } else {
      setEmailError(true);
    }
  }

  const [recaptchaValue, setRecaptchaValue] = useState("");
  const recaptchaRef = useRef();
  const resetCaptcha = async (event) => {
    if (recaptchaRef.current) {
      // Reset the reCAPTCHA
      recaptchaRef.current.reset();
    }
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  return (
    <>
      <ToastContainer />
      <div className=" " style={{ background: "#f1f1ff" }}>
        <div
          className="col-xl-12 "
          style={{
            height: "100dvh",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div className=" border-0 d-flex justify-content-center">
            <div className=" card login-bx" style={{ width: "80%" }}>
              <div className="row custome-row">
                <div
                  className="col-xl-6 col-md-6  text-center d-flex justify-content-center align-items-center "
                  style={{ borderRight: "1px solid lightgray" }}
                >
                  {/* <img src={logo} alt="" style={{ width: '250px' }} /> */}
                  <Slider />
                </div>
                <div className="col-xl-6 col-md-6  d-flex cutome-col align-items-center justify-content-center overflow-auto">
                  <div className="sign-in-your mt-3 " style={{ width: "90%" }}>
                    <div className="row d-flex justify-content-center">
                      <img
                        src={logo}
                        style={{ width: "150px", cursor: "pointer" }}
                        alt=""
                      />
                    </div>
                    <div className="row mt-1"></div>

                    <div className="row mt-4">
                      <span
                        className="login-title"
                        style={{ textAlign: "center", fontWeight: "600" }}
                      >
                        Forgot Password
                      </span>
                    </div>

                    <div className="row mt-4">
                      <div>
                        <InputField
                          labelName={"Email"}
                          onChange={(e) => {
                            setEmailError(false);
                            setEmail(e.target.value);
                          }}
                          value={email}
                          errorOccured={emailError}
                          errorMeesage={"Please enter valid email"}
                          onClick={() => {
                            onForgot();
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group text-left d-flex justify-content-between mt-2">
                      <span className="form-check d-inline-block ms-2"></span>
                      <p
                        style={{ color: "#9568FF", cursor: "pointer" }}
                        onClick={() => {
                          navigate("/login");
                        }}
                      >
                        Go back to login ?
                      </p>
                    </div>
                    <div
                      style={{
                        maxWidth: "100%",
                        textAlign: "center",
                        marginBottom: "15px",
                      }}
                    >
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6Leo7aAsAAAAACB5HBnsNIXzRHCVntxILf5ckg8B" // Replace with your reCAPTCHA site key
                        onChange={handleRecaptchaChange}
                      />
                    </div>
                    <PrimaryButton
                      buttonName={"Get Link"}
                      type={"submit"}
                      isLoading={loadingActive}
                      loadingMessage={"Loading..."}
                      style={{
                        width: "100%",
                      }}
                      onClick={() => {
                        onForgot();
                      }}
                    />

                    <div className="row d-flex justify-content-center mt-3">
                      {/* Apple Signin custom Button for login */}
                      <div className="col-12 d-flex justify-content-center">
                        <div className="buttoncover"></div>
                      </div>
                    </div>

                    <div className="row ">
                      <p style={{ textAlign: "center" }}>
                        By continuing, you agree to V2P<br></br>
                        <div className="">
                          <a
                            className="terms-condition-link"
                            href="https://www.vendortopay.com/Home/terms-and-conditions.html"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {"Terms of Service "}
                          </a>
                          <span>and</span>
                          <a
                            href="https://vayana.com/privacy-policy/#:~:text=Vayana%20Network%20will%20not%20sell,the%20processing%20of%20the%20transaction"
                            className="terms-condition-link"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" Privacy Policy"}
                          </a>
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPasswordAuth;
